// Boton reutilizable con dos variantes del design system:
// - "primario": fondo charcoal con texto blanco (alto impacto)
// - "secundario": estilo outline con borde peanut
const ESTILOS = {
  primario:
    "bg-charcoal text-white hover:bg-ink hover:shadow-card-hover focus-visible:ring-charcoal",
  secundario:
    "bg-transparent text-charcoal border-2 border-peanut hover:bg-peanut/20 focus-visible:ring-peanut",
};

const Boton = ({
  children,
  variante = "primario",
  type = "button",
  onClick,
  className = "",
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-3 rounded-xl px-8 py-4 text-base font-semibold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${ESTILOS[variante]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Boton;
